const types = {
  SET_SYS: 'system/SET_SYS',
  SET_SYSNO: 'system/SET_SYSNO',
  SET_SYSID: 'system/SET_SYSID',
  SET_SYSTITLE: 'system/SET_SYSTITLE',
  SET_SETTING: 'system/SET_SETTING',
  SET_OPTIONNO: 'system/SET_OPTIONNO',
  SET_SYSINFO: 'system/SET_SYSINFO'
}

const state = {
  sysInfo: {
    sysNo: '',
    sysId: 0,
    tytle: ''
  },
  settingInfo: null,
  optionNo: ''
}

const getters = {
  getSchYY: state => {
    return state.sysInfo.schYY
  },
  getSysInfo: state => {
    return state.sysInfo
  },
  getSysId: state => {
    return state.sysInfo.sysId
  },
  getSysNo: state => {
    return state.sysInfo.sysNo
  },
  getSysTitle: state => {
    return state.sysInfo.tytle
  },
  getSetting: state => {
    return state.settingInfo
  },
  getOptionNo: state => {
    return state.optionNo
  }
}

const actions = {
  setSysInfo ({ commit }, obj) {
    //console.log('setSysInfo', obj)
    commit(types.SET_SYS, obj)
  },
  setSysNo ({ commit }, obj) {
    //console.log('setSysNo', obj)
    commit(types.SET_SYSNO, obj)
  },
  setSysId ({ commit }, obj) {
    //console.log('setSysId', obj)
    commit(types.SET_SYSID, obj)
  },
  setSysTitle ({ commit }, obj) {
    commit(types.SET_SYSTITLE, obj)
  },
  setSetting ({ commit }, obj) {
    commit(types.SET_SETTING, obj)
  },
  setOptionNo ({ commit }, obj) {
    commit(types.SET_OPTIONNO, obj)
  },
  setSysInfo ({ commit }, obj) {
    commit(types.SET_SYSINFO, obj)
  }
}

const mutations = {
  // 更新 System Info
  [types.SET_SYS] (state, obj) {
    state.sysInfo = obj
  },
  // 更新 Setting Info
  [types.SET_SETTING] (state, obj) {
    state.settingInfo = obj
  },
  // 更新 Setting Info
  [types.SET_SYSNO] (state, region) {
    state.sysInfo.sysNo = region
  },
  [types.SET_SYSID] (state, keyword) {
    state.sysInfo.sysId = keyword
  },
  [types.SET_SYSTITLE] (state, keyword) {
    state.sysInfo.tytle = keyword
  },
  [types.SET_OPTIONNO] (state, keyword) {
    state.optionNo = keyword
  },
  [types.SET_SYSINFO] (state, keyword) {
    state.sysInfo.schYY = keyword.schYY
    state.sysInfo.smt = keyword.smt
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
